<template>
    <div v-if="scope.row[config.prop] !=undefined">
        <el-input-number
            v-model.number="scope.row[config.prop]"
            controls-position="right"
            :min="0"
            size="small"
            placeholder="请输入排序值"
        >
        </el-input-number>
    </div>
    <div v-else>
        无对应字段~
    </div>
</template>

<script>
export default {
    name: "TDefaultSort",
    cName:'排序',
    defaultProp:'sort',
    // functional: true,
    // Props 是可选的
    props: ["scope", "config"],
    data() {
        return {};
    }
};
</script>
